export const STATUS_BAR_HEIGHT_ANDROID = 25;
